import {
  AddOnErrorEvent,
  AuthenticateEvent,
  CartChangeEvent,
  ContinueEvent,
  NavigationEvent,
} from './event.interface';
import {EventEmitter} from '@angular/core';

export interface CommerceEventEmitter {
  cartLoad?: EventEmitter<CartChangeEvent>;
  cartUpdate?: EventEmitter<CartChangeEvent>;
  addOnError?: EventEmitter<AddOnErrorEvent>;
  authenticate?: EventEmitter<AuthenticateEvent>;
}

export interface CommerceNavigationEventEmitter extends CommerceEventEmitter {
  continue?: EventEmitter<ContinueEvent>;
  navigation?: EventEmitter<NavigationEvent>;
}

export const isCommerceNavigationEventEmitter = (
  emitter: CommerceEventEmitter | CommerceNavigationEventEmitter,
): emitter is CommerceNavigationEventEmitter => {
  return (emitter as CommerceNavigationEventEmitter).continue !== undefined;
};
